var TYPE = "PARTNER_ID_REQUEST";
export var isPartnerIdRequestMessage = function isPartnerIdRequestMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};
export var partnerIdRequestMessage = function partnerIdRequestMessage() {
  return {
    type: TYPE,
    payload: null
  };
};